<template>
  <toolbar-container>
    <template #toolbar>
      <reports-toolbar />
    </template>
    <v-row class="pa-0 ma-0">
      <v-col
        cols="12"
        class="pa-0 ma-0 mb-3"
      >
        <services-revenue-chart
          :category-type="services.categoryType"
          :category="services.category"
          :series="services.series"
          :dataset="services.dataset"
          :totals="services.totals"
          :series-revenue="servicesRevenue.series"
          :dataset-revenue="servicesRevenue.dataset"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="pa-0 ma-0 pr-md-3 pb-3 pb-lg-0"
      >
        <mini-pie-chart
          :title="$t('label.report_by_reservations')"
          :dataset="reportsServicesPie.datasetByReservations"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="pa-0 ma-0 pr-lg-3 pb-3 pb-lg-0"
      >
        <mini-pie-chart
          :title="$t('label.report_by_guests')"
          :dataset="reportsServicesPie.datasetByGuests"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="pa-0 ma-0 pr-md-3 pr-lg-0"
      >
        <mini-pie-chart
          :title="$t('label.report_by_revenue')"
          :dataset="reportsServicesPie.datasetByRevenue"
        />
      </v-col>
    </v-row>
  </toolbar-container>
</template>

<script lang="ts">
import Vue from 'vue';

import ReportsToolbar from '@/components/views/reports/ReportsToolbar.vue';
import MiniPieChart from '@/components/views/reports/MiniPieChart.vue';
import ServicesRevenueChart from '@/components/views/reports/ServicesRevenueChart.vue';
import { loadStoreModule, unloadStoreModule } from '@/services/module-loader';
import ReportsStore from '@/store/reports-store';
import { ChartData, PieChartData } from '@/services/reports-utils';
import { ReportsType } from '@/services/reports';

export default Vue.extend({
  name: 'ReportServices',
  components: {
    ReportsToolbar, ServicesRevenueChart, MiniPieChart,
  },
  data() {
    return {};
  },
  computed: {
    services(): ChartData { return this.$tstore.getters.reportsServices; },
    servicesRevenue(): ChartData { return this.$tstore.getters.reportsServicesRevenue; },
    reportsServicesPie(): {
      datasetByReservations: PieChartData,
      datasetByGuests: PieChartData,
      datasetByRevenue: PieChartData,
    } {
      return this.$tstore.getters.reportsServicesPie;
    },
  },
  created() {
    loadStoreModule(this, 'reports', ReportsStore, async () => {
      this.$tstore.dispatch('updateReports', { reportsType: ReportsType.Services });
    });
  },
  beforeDestroy() {
    unloadStoreModule(this, 'reports', async () => { this.$tstore.dispatch('resetReports'); });
  },
  methods: {},
});

</script>
